export enum Types {
  DEFAULT = 'default',
  SPECIAL = 'special',
  ROUNDED = 'rounded',
  WITHICON = 'withIcon'
}
